import PropTypes from 'prop-types'
import React from 'react'
import { ReportItem } from '../report_item/report_item'
import { FlexContainer, FlexItem } from './styled'

const ReportList = ({ reports }) => (
  <FlexContainer>
    {reports && reports.map(({ ident }, idx) => (
      <FlexItem key={idx}>
        <ReportItem reportId={ident} />
      </FlexItem>
    ))}
  </FlexContainer>
)

ReportList.propTypes = {
  reports: PropTypes.any.isRequired
}

export { ReportList }
